// Third-party packages
import React, { useContext, useState, useEffect } from 'react'
import {
  Button,
  Container,
  Header,
  Icon,
  Item,
  Loader,
  Menu,
  Dropdown,
} from 'semantic-ui-react'

// Main packages
import { AppContext } from './app_context'
import * as api from '../api'

const SectionHeader = () => {

  // Global app state
  const app = useContext(AppContext)
  
  // Authentication state
  const [customer, setCustomer] = useState(null)
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  // Check authentication status on component mount
  useEffect(() => {
    const checkAuth = () => {
      const isAuth = api.isAuthenticated()
      setIsAuthenticated(isAuth)
      
      if (isAuth) {
        const customerInfo = api.getCustomerInfo()
        setCustomer(customerInfo)
        
        // Track authenticated user session with retry logic
        if (customerInfo) {
          const trackCustomerLogin = () => {
            if (window.faroTracker && typeof window.faroTracker.trackEvent === 'function') {
              window.faroTracker.trackEvent('customer_login', {
                customerId: customerInfo.id,
                email: customerInfo.email,
                timestamp: Date.now()
              })
            } else {
              // Retry after a short delay if Faro isn't ready yet
              setTimeout(trackCustomerLogin, 100)
            }
          }
          trackCustomerLogin()
        }
      } else {
        setCustomer(null)
      }
    }
    
    checkAuth()
    
    // Listen for storage changes (login/logout in other tabs)
    const handleStorageChange = (e) => {
      if (e.key === 'auth_token' || e.key === 'customer_id') {
        checkAuth()
      }
    }
    
    window.addEventListener('storage', handleStorageChange)
    
    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [])

  const handleLogout = () => {
    api.logout()
    setIsAuthenticated(false)
    setCustomer(null)
    
    // Refresh cart after logout
    if (app.refreshCart) {
      app.refreshCart(true)
    }
    
    // Redirect to home page
    window.location.href = '/'
  }

  const css = `#root { padding-top: 4em }`
  return (<>
    <style type='text/css'>
      {css}
    </style>
    <Menu borderless fixed={'top'}>
      <Container>
        <Menu.Item as='a' href='/'>
          <Header size='medium'>
            <span style={{ color: '#000' }}>Grafana Labs</span>
            <Header.Subheader>
              &nbsp;
            </Header.Subheader>
          </Header>
        </Menu.Item>
        
        <Menu.Item position='right'>
          {/* Authentication Section */}
          {isAuthenticated && customer ? (
            <Dropdown
              text={`Welcome, ${customer.name?.split(' ')[0] || customer.email}`}
              icon='user'
              labeled
              button
              className='icon'
              style={{ marginRight: '10px' }}
            >
              <Dropdown.Menu>
                <Dropdown.Item>
                  <Icon name='user' />
                  {customer.email}
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item as='a' href='/profile'>
                  <Icon name='setting' />
                  Profile Settings
                </Dropdown.Item>
                <Dropdown.Item onClick={handleLogout}>
                  <Icon name='sign out' />
                  Sign Out
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <div style={{ marginRight: '10px' }}>
              <Button as='a' href='/login' basic color='blue' size='small'>
                Sign In
              </Button>
              <Button as='a' href='/register' color='blue' size='small' style={{ marginLeft: '5px' }}>
                Sign Up
              </Button>
            </div>
          )}
          
          {/* Cart Button */}
          <Button as='a' href='/cart' animated='vertical' color='blue' style={{ minWidth: '160px' }}>
            <Button.Content visible>
              <Icon name='shop' /> {app.cart.size || 0}
            </Button.Content>
            <Button.Content hidden>
              View Cart
            </Button.Content>
            <Loader active={app.cart.size === null} inverted />
          </Button>
        </Menu.Item>
      </Container>
    </Menu>
  </>)
}

export default SectionHeader
